const BASE_URL = 'hearthunter/hhrestservice/';

async function request(api, data) {
	let params = new URLSearchParams();
	for (const key in data) {
		params.append(key, data[key]);
	}
	const url = `${BASE_URL}${api}?${params.toString()}`;
	const response = await fetch(url);
	const json = await response.json();
	if (!json.success) {
		throw json.message;
	}
	return json;
}

export default window.HHServer = new class {
	async createSessionManager() {
		return await request('createsessionmanager');
	}

	async deleteSessionManager() {
		return await request('deletesessionmanager');
	}

	/**
	 * @param {Object} data Settings
	 * @param {string} data.version Game version
	 * @param {string} data.mode Game type
	 * @param {number} data.width Board width
	 * @param {number} data.height Board height
	 * @param {string} data.level Game level
	 * @param {number} data.limit Max conflicts
	 */
	async changeSetting(data) {
		return await request('changesetting', data);
	}

	async getSetting() {
		return await request('getsetting');
	}

	async startGame() {
		return await request('startgame');
	}

	/**
	 * @param {number} pid Player ID
	 */
	async breakParty(pid) {
		return await request('breakparty', { pid });
	}

	/**
	 * @param {Object} data Stone data
	 * @param {number} data.pid Player ID
	 * @param {number} data.x X
	 * @param {number} data.y Y
	 * @param {number} data.d Direction (0..3)
	 * @param {number} data.p Player ID
	 */
	async pingPosition(data) {
		return await request('pingposition', data);
	}

	/**
	 * @param {Object} data Stone data
	 * @param {number} data.pid Player ID
	 * @param {number} data.x X
	 * @param {number} data.y Y
	 * @param {number} data.d Direction (0..3)
	 * @param {number} data.p Player ID
	 */
	async placeStone(data) {
		return await request('placestone', data);
	}

	/**
	 * @param {number} pid Player ID
	 */
	async processMove(pid) {
		return await request('processmove', { pid });
	}

	/**
	 * @param {number} pid Player ID
	 */
	async revokeLastMove(pid) {
		return await request('revokelastmove', { pid });
	}
}